import { render, staticRenderFns } from "./ProductPurchaseHistory.vue?vue&type=template&id=0dbdf78b&lang=pug&"
import script from "./ProductPurchaseHistory.vue?vue&type=script&lang=js&"
export * from "./ProductPurchaseHistory.vue?vue&type=script&lang=js&"
import style0 from "./ProductPurchaseHistory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports